import React from "react";
import { Provider } from "../interfaces/intefaces";

interface IProps {
  providers: Provider[]
  handleProviderGrid: (prs: number[]) => void

}

const ProvidersGrid: React.FC<IProps> = ({ providers, handleProviderGrid }) => {

  return (
    <div className="providers-grid flex">
      {providers && providers.map((provider) => {
        return <div className="provider" onClick={() => handleProviderGrid([provider.id])}>
            <svg className="provider_svg"><use xlinkHref={`#${provider.slug}`}></use></svg>
            <span className="provider-title">{provider.name}</span>
        </div>
      })}
    </div>
  );
}

export default ProvidersGrid;